package fyi.moko.hotpl.data.location

class JsLocationContextResolver : LocationContextResolver {
    override suspend fun resolve(latitude: Double, longitude: Double): String? {
        return "Web Location"
    }
}
